/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AppointmentFormatEnum } from './appointmentFormatEnum';
import { TreatmentTypeEnum } from './treatmentTypeEnum';
import { SessionTypeEnum } from './sessionTypeEnum';


import {ValidatorFn, Validators} from "@angular/forms";

export interface AppointmentTypeFilter { 
    patientId: string;
    therapistId?: number | null;
    practiceIds?: Array<number>;
    lengthInMin?: number | null;
    /**
     * Without explicit practice_ids, only return types in the patient\'s own practice (if set).
     */
    restrictToPatientPractice?: boolean;
    sessionType: SessionTypeEnum;
    appointmentFormat: AppointmentFormatEnum;
    treatmentType: TreatmentTypeEnum;
}
export namespace AppointmentTypeFilter {
}

export const AppointmentTypeFilter_patientId_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AppointmentTypeFilter_therapistId_Validators: ValidatorFn[] =
    [ ];

export const AppointmentTypeFilter_practiceIds_Validators: ValidatorFn[] =
    [ ];

export const AppointmentTypeFilter_lengthInMin_Validators: ValidatorFn[] =
    [ ];

export const AppointmentTypeFilter_restrictToPatientPractice_Validators: ValidatorFn[] =
    [ ];

export const AppointmentTypeFilter_sessionType_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AppointmentTypeFilter_appointmentFormat_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AppointmentTypeFilter_treatmentType_Validators: ValidatorFn[] =
    [  Validators.required, ];


